


































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDeliveryShipper from '@/components/filters/FilterDeliveryShipper.vue'
import DeliveryShipperResponse from '@/model/response/DeliveryShipperResponse'
import DeliveryShipperRequest from '@/model/request/DeliveryShipperRequest'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryShipper.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliveryShipper},
})
export default class ReportsDeliveryShipperView extends Mixins(MixinFilter) {
  filter = new DeliveryShipperRequest()
  collection = new PageCollection(DeliveryShipperResponse, this.filter, 10)

  AppConfig = AppConfig

  async created() {
    this.collection.orderBy = 'nome'
    this.collection.asc = true
  }

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
        const csv = new PageCollection(DeliveryShipperResponse, this.filter, null, null)

        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv(snakeCase($.t('view.reports.deliveryShipper.title')))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.deliveryShipper.title'),
          new DeliveryShipperResponse().$endpoint,
          this.filter,
          DeliveryShipperResponse,
          'DeliveryShipperResponse',
          ), 'download')
    }
  }
}
